import { requestAPI } from 'utils/api'


export const readConditions = (type?: string) => {
  return requestAPI({
    method: 'GET', url: `/gamesetting/options/conditions`, params: { type }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBoxIds = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/boxids'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readItemIds = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/itemids'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readProductIds = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/productids'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readVipTiers = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/viptiers'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readItemFile = () => {
  return requestAPI({
    method: 'GET', url: '/s3/itemtable'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readItemRecord = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/itemrecord'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateItemFile = (params: FormData) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/itemtable/validate', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const uploadItemFile = (params: FormData) => {
  return Promise.all([
    requestAPI({ method: 'POST', url: '/s3/itemtable', params }),
    requestAPI({ method: 'POST', url: '/s3/itemtableDB', params })
  ]).then(([_, result]) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readSegmentIds = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/segmentids'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readWebLinks = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/weblinks'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateWebLink = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/weblinks/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readMaxRewards = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/maxrewards'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMaxRewards = (option_id: any, max_value: any, log: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/maxrewards/${option_id}`, params: { max_value, log }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGameSettings = (type?: 'elo' | 'etc' | 'cashbounceback') => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/settings', params: { type }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateGameSetting = (key: any, value: any, log: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/settings/${key}`, params: { value, log }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readAdRewards = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/meta/ads'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateAdRewards = (params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/meta/ads`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readVipInfo = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/meta/vip'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateVipInfo = (params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/meta/vip`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createDailyRewards = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/meta/dailyrewards', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readDailyRewards = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/meta/dailyrewards'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateDailyRewards = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/meta/dailyrewards/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteDailyRewards = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/gamesetting/meta/dailyrewards/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readLevelRewards = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/meta/levelrewards'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateLevelRewards = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/gamesetting/meta/levelrewards/validate`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const importLevelRewards = (params: any) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/meta/levelrewards/import', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readCurrencyMcode = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/mcode'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createCurrencyMcode = (data: any, additional?: any[]) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/mcode', params: { data, additional }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateCurrencyMcode = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/mcode/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readRandomBox = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/randombox'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createRandomBox = (data: any, additional?: any[]) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/randombox', params: { data, additional }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateRandomBox = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/gamesetting/randombox/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteRandomBox = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/gamesetting/randombox/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGameVersions = () => {
  return requestAPI({
    method: 'GET', url: '/gamesetting/gameversion'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createGameVersion = (package_name: string, version: string) => {
  return requestAPI({
    method: 'POST', url: '/gamesetting/gameversion', params: { package_name, version }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateGameVersion = (prev_package_name: string, prev_version: string, package_name: string, version: string) => {
  return requestAPI({
    method: 'PATCH', url: '/gamesetting/gameversion', params: { prev_package_name, prev_version, package_name, version }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteGameVersion = (package_name: string, version: string) => {
  return requestAPI({
    method: 'DELETE', url: `/gamesetting/gameversion/${package_name}/${version}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}
